<script>
export default {
  name: "MenuItem",
  functional: true,
  props: {
    icon: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  render(h, context) {
    const { icon, title } = context.props;
    const vnodes = [];

    if (icon) {
      vnodes.push(<svg-icon icon-class={icon} />);
    }

    if (title?.length >= 9) {
      // vnodes.push(<span slot='title'>{(title)}</span>)
      vnodes.push(
        <el-tooltip
          slot="title"
          effect="dark"
          content={title}
          placement="top"
          visible-arrow={false}
        >
          <span>{title}</span>
        </el-tooltip>
      );
    } else {
      vnodes.push(<span slot="title">{title}</span>);
    }
    return vnodes;
  },
};
</script>
